import React from "react";

//interfaces
import { IIconComponentProps } from "@/types/components/IconComponentProps";

function AdvancedFilterIcon(props: IIconComponentProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16.6667 5.83398H7.5M3.33333 14.1673H12.5M6.76776 4.06622C7.74407 5.04252 7.74407 6.62544 6.76776 7.60175C5.79146 8.57806 4.20854 8.57806 3.23223 7.60175C2.25592 6.62544 2.25592 5.04252 3.23223 4.06622C4.20854 3.08991 5.79146 3.08991 6.76776 4.06622ZM16.7677 12.3996C17.7441 13.3759 17.7441 14.9588 16.7677 15.9351C15.7914 16.9114 14.2085 16.9114 13.2322 15.9351C12.2559 14.9588 12.2559 13.3759 13.2322 12.3996C14.2085 11.4233 15.7914 11.4233 16.7677 12.3996Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default AdvancedFilterIcon;
